import { queryOptions } from '@tanstack/react-query';

import { TICKETS_PREFIX } from 'restful/tickets/constants';
import { RestApiError } from 'services/api/restful/errors';
import type { LoyaltyEffect } from 'services/api/restful/generated/nofomoRestApi.schemas';

type LoyaltyEffectsQueryData = Array<LoyaltyEffect>;

/** Cache-only query — populated by `useSimulateLoyaltyCartUpdate`. */
export const loyaltyEffectsQuery = queryOptions<
  LoyaltyEffectsQueryData,
  RestApiError
>({
  queryKey: [TICKETS_PREFIX, 'loyalty-effects'],
});
